import { render, staticRenderFns } from "./Book-Lesson.vue?vue&type=template&id=2d82f870&scoped=true&lang=html"
import script from "./Book-Lesson.vue?vue&type=script&lang=js"
export * from "./Book-Lesson.vue?vue&type=script&lang=js"
import style0 from "./Book-Lesson.vue?vue&type=style&index=0&id=2d82f870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82f870",
  null
  
)

export default component.exports